import {ComparatorConfig} from "../models/ComparatorConfig";
import {Checkbox, FormControlLabel, IconButton, Stack, TextField} from "@mui/material";
import React from "react";
import {translateFunction} from "../../../localization/TranslationService";
import {openNewTab} from "../../../libraries/util/Functions";
import {OpenInNew} from "@mui/icons-material";

export interface AfmLicenseProps {
	readonly comparatorConfig: ComparatorConfig;
	readonly setComparatorConfig: (comparatorConfig: ComparatorConfig) => void;
	readonly disabled: boolean;
}

export function AfmLicense(props: AfmLicenseProps) {
	const translate = translateFunction("SureBasePortalProductsCatalog");
	
	function nullIfEmpty(value: string): string | null {
		if (value === "")
			return null;
		return value;
	}
	
	return <div style={{height: "40%", overflow: "auto"}}>
		<Stack spacing={2} sx={{p: 3}}>
			<div>{translate("AfmLicense")}</div>
			<TextField
				variant={"standard"}
				label={translate("Name")}
				value={props.comparatorConfig.afmLicense.name ?? ""}
				style={{flexGrow: 1}}
				onChange={event => {
					const newItem = {...props.comparatorConfig.afmLicense, name: event.target.value};
					props.setComparatorConfig({...props.comparatorConfig, afmLicense: newItem});
					
				}}
			/>
			
			<TextField
				variant={"standard"}
				label={translate("Number")}
				value={props.comparatorConfig.afmLicense.number ?? ""}
				style={{flexGrow: 1}}
				onChange={event => {
					const newItem = {...props.comparatorConfig.afmLicense, number: event.target.value};
					props.setComparatorConfig({...props.comparatorConfig, afmLicense: newItem});
					
				}}
			/>
			
			<FormControlLabel
				control={<Checkbox
					checked={props.comparatorConfig.afmLicense.isUrl}
					disabled={props.disabled}
					onChange={event => {
						const newItem = {...props.comparatorConfig.afmLicense, isUrl: event.target.checked};
						props.setComparatorConfig({...props.comparatorConfig, afmLicense: newItem});
						
					}}
				/>}
				label={translate("Is Name a Url?")}
			/>
			
			<TextField
				label={translate("Affiliate Url")}
				value={props.comparatorConfig.afmLicense.url ?? ""}
				variant={"standard"}
				disabled={props.disabled || !props.comparatorConfig.afmLicense.isUrl}
				onChange={event => {
					const newItem = {...props.comparatorConfig.afmLicense, url: nullIfEmpty(event.target.value)};
					props.setComparatorConfig({...props.comparatorConfig, afmLicense: newItem});
					
				}}
				InputProps={{
					startAdornment: props.comparatorConfig.afmLicense.url
						&& <IconButton onClick={() => openNewTab(props.comparatorConfig.afmLicense.url)}>
							<OpenInNew/>
						</IconButton>
				}}
			/>
		</Stack>
	</div>;
}
